import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (ios) {
      setIsIOS(true);
      setVisible(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => setVisible(false));
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = async () => {
    if (isIOS) {
      alert("Para instalar: pulsa el botón Compartir ⬆️ en Safari y elige 'Añadir a pantalla de inicio'.");
      return;
    }
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-5 left-5 z-[60]" data-testid="install-pwa">
      <div className="glass rounded-full pl-4 pr-2 py-2 flex items-center gap-3 shadow-2xl">
        <span className="text-sm text-white/90 font-medium">Instala la app</span>
        <button
          data-testid="install-pwa-button"
          onClick={onClick}
          className="flex items-center gap-1.5 h-9 px-4 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500 hover:from-indigo-400 hover:to-violet-400 text-white text-sm font-medium transition-colors"
        >
          <Download className="h-4 w-4" /> Instalar
        </button>
        <button data-testid="install-pwa-dismiss" onClick={() => setVisible(false)} className="text-white/50 hover:text-white p-1">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
